module.exports = __webpack_public_path__ + "static/media/GothamRnd-Bold.68c3d9d1.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Bold.eot
 ** module id = 1344
 ** module chunks = 0
 **/